import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse ,HttpHeaders } from '@angular/common/http';
import { BASE_URL } from '../environments/environment';
import {UPLOAD_USER_IMG, APP_SETTINGS} from 'src/app/constants';
import { HelperService} from './helper.service';



@Injectable({
  providedIn: 'root'
})


export class ApiService {  

 
  //headers = { 'Content-Type': 'application/json ', 'Authorization': 'Bearer ' + this.helperService.getToken() }


  constructor(private httpClient: HttpClient,
    private helperService:HelperService) {
    
    
  }
  
  
   public getVenDetails(data){
     
    const vendortypeurl = BASE_URL + "vendor-types";    
    return this.httpClient.get(vendortypeurl,this.helperService.headertoken(data));
  }
  public getspetialityDetails(data){
    const specilityurl = BASE_URL + "vendor-speciality"
    return this.httpClient.get(specilityurl,this.helperService.headertoken(data));
  }
  
  public getSpecialityCategory(data){
    const categoryspecilityurl = BASE_URL +"category-speciality"
    return this.httpClient.get(categoryspecilityurl,{params: data});
  }

  public getSpecialityData(data){
    const specilityurl = BASE_URL+"speciality";
    return this.httpClient.get(specilityurl,{params: data});
  }
  public getSearchResults(data){
    const searchurl = BASE_URL+"search-list";
    return this.httpClient.get(searchurl,{params: data});
  }
  public businessDetails(data){
    const businessDetailsurl = BASE_URL+"business-details";
    return this.httpClient.get(businessDetailsurl,this.helperService.headertoken(data));
  }
  public batchList(data){
    const batchListListurl = BASE_URL+ "pkg-details";
    return this.httpClient.get(batchListListurl,{params: data});
  }

  public enrollmentList(data){
    const EnrollmentListurl = BASE_URL+ "host-booking-lists";
    return this.httpClient.get(EnrollmentListurl,{params: data});
  }
  
  public courseList(data){
    const courseListurl = BASE_URL+ "student-course-list";
    return this.httpClient.get(courseListurl,this.helperService.headertoken(data));
  }
  public assignmentList(data){
    const asslignListurl = BASE_URL+ "student-assig-list";
    return this.httpClient.get(asslignListurl,{params: data});
  }

  public classType(data){
    const classTypeListurl = BASE_URL+ "class-types";
    return this.httpClient.get(classTypeListurl,{params: data});
  }

  public hostLogin(data){   
   
    const hostLoginurl = BASE_URL+ "hostLogin";
    return this.httpClient.post(hostLoginurl,data);
   
  }

  public checkUser(data){
    /*var token= this.helperService.studented_atob(this.helperService.getToken());
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization':token
      }),
      params: data
    };*/
   // console.log(token);
    //const headers = { 'Authorization': data.token,params: data }

    const checkUserUrl =  BASE_URL+"check-user";
    return this.httpClient.get(checkUserUrl,this.helperService.headertoken(data));
  }  

  public signUp(data){
    const signuploginUrl = BASE_URL+"signup";
    return this.httpClient.post(signuploginUrl,data);
  }

  public saveMessage(data){
    const savemessageloginUrl = BASE_URL+"saveMessage";
    return this.httpClient.post(savemessageloginUrl,data);
  }
  
  public registerDevice(data){ 
    var token= this.helperService.studented_atob(this.helperService.getToken());
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization':token
      }),
      //params: data
    };
   // console.log(token);
    //const headers = { 'Authorization': data.token,params: data }   ]
    const registerDeviceUrl = BASE_URL+"register-device";
    return this.httpClient.post(registerDeviceUrl,data,httpOptions);
  }
  public packageDetails(data){
    const packageDetailsUrl = BASE_URL+"pkg-details";
    return this.httpClient.get(packageDetailsUrl,this.helperService.headertoken(data));
  } 

  public classSearchList(data){
    const classSearchList = BASE_URL+"class-search-list";
    return this.httpClient.get(classSearchList,{params: data});
  }

  public assessmentList(data){
    const assessmentListurl = BASE_URL+"student-assessment-list";
    return this.httpClient.get(assessmentListurl,{params: data});
  }

  public noticeInstituteList(data){
    const InstituteListurl = BASE_URL+"notice-institute-list";
    return this.httpClient.get(InstituteListurl,{params: data});
  }
  public noticeList(data){
    const NoticeListurl = BASE_URL+"notice-list";
    return this.httpClient.get(NoticeListurl,{params: data});
  }
  public noticeDetailsList(data){
    const NoticeListurl = BASE_URL+"notice-details";
    return this.httpClient.get(NoticeListurl,{params: data});

  }

  public enquiryList(data){
    const EnquiryListurl = BASE_URL+"host-enquiry-lists";
    return this.httpClient.get(EnquiryListurl,this.helperService.headertoken(data));

  }

  public contentList(data){
    const ContentListurl = BASE_URL+"public-content-list";
    return this.httpClient.get(ContentListurl,{params: data});
  }

  public publishList(data){
    const ContentListurl =BASE_URL+"publish-list";
    return this.httpClient.get(ContentListurl,{params: data});
  }

  public publishDetails(data){
    const ContentDetailsurl = BASE_URL+"publish-details";
    return this.httpClient.get(ContentDetailsurl,{params: data});
  }  

  public userDetails(data){
    const UserListurl = BASE_URL+"user-details"; 
    return this.httpClient.get(UserListurl,this.helperService.headertoken(data));
  }
  public hostuserDetails(data){
    const UserListurl = BASE_URL+"host-user-details"; 
    return this.httpClient.get(UserListurl,this.helperService.headertoken(data));
  }

  public enrollmentDetails(data){
    const EnrollmentListurl = BASE_URL+"host-booking-details";
    return this.httpClient.get(EnrollmentListurl,{params: data});
  }

  forgetPwdResendOTP(userEmail) {
    const url = BASE_URL + "re-send-otp";
    return this.httpClient.post(url, {userEmail});
  }

  userAuthenticateOtp(data) {
    const userAuthenticateUrl = BASE_URL+"verify-user";
    return this.httpClient.post(userAuthenticateUrl, data);
  }

  createCustomerEnquiry(data){


    var token= this.helperService.studented_atob(this.helperService.getToken());
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization':token
      }),
      //params: data
    };

    const customerEnquiry = BASE_URL+"create-customer-enquery";
    return this.httpClient.post(customerEnquiry,data,httpOptions);
  }

  hostEnquiryDetails(data){
    const hostEnquiry = BASE_URL+"host-enquiry-details";
    return this.httpClient.get(hostEnquiry,this.helperService.headertoken(data));
  }

  updateUserProPic(user_data, image_data: File, ext) {

    const formData: FormData = new FormData();
    formData.append('userProfileImg', image_data, image_data.name + ext);
    console.log("teye");

    const url = `${BASE_URL}${UPLOAD_USER_IMG}?token=${user_data.token}&userID=${user_data.userID}&vendorID=${user_data.vendorID}`;
    //const url = BASE_URL + UPLOAD_USER_IMG;
    console.log(url);
    return this.httpClient.post(url, formData);
   
  }

  studentCourseDetails(data){ 
    const studentCourseDetails = BASE_URL+"student-course-detail";
    return this.httpClient.get(studentCourseDetails,this.helperService.headertoken(data) );
  }
  createJob(data){
    const createJob = BASE_URL+"create-job";
    return this.httpClient.post(createJob, data);
  } 

  joblist(data){ 
    const joblist = BASE_URL+"job-list";
    return this.httpClient.get(joblist, this.helperService.headertoken(data));
  }

  saveContact(data){
    const contact = BASE_URL+"contact-us";
    return this.httpClient.post(contact, data);
  }
  sendOTP(userEmail){
    const otp = BASE_URL+"send-otp";
    return this.httpClient.post(otp, {userEmail});
  }
  verifyOTP(data){
    const otp = BASE_URL+"verify-otp";
    return this.httpClient.post(otp, data  );
  }
  changePassword(data){
    const changePassword = BASE_URL+"change-pass";
    return this.httpClient.post(changePassword, data);
  }

  updateEnquiryStatus(data) {
    const updateEnquiryStatus = BASE_URL+"accept-reject-package";
    
    return this.httpClient.post(updateEnquiryStatus,data, this.helperService.headertoken(data));
  }

  getAppSettings() {
    const url = BASE_URL + APP_SETTINGS;
    return this.httpClient.get(url);
  }

  }



 

